(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  document.querySelectorAll('.quantity-selector').forEach(function (el) {
    var input = el.querySelector('.quantity-selector__input');
    el.querySelector('[aria-label="Decrease quantity"]').addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value || 0) - 1);
    });
    el.querySelector('[aria-label="Increase quantity"]').addEventListener('click', function () {
      input.value = parseInt(input.value || 0) + 1;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var hamburger = document.querySelector('.site-header__hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var closeBtn = document.querySelector('.mobile-nav__close');
  var backdrop = document.querySelector('.mobile-nav__backdrop');

  if (!hamburger || !mobileNav) return;

  function openNav() {
    mobileNav.classList.add('is-open');
    mobileNav.removeAttribute('inert');
    mobileNav.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-visible');
    hamburger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeNav() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('inert', '');
    mobileNav.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-visible');
    hamburger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    hamburger.focus();
  }

  hamburger.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (backdrop) backdrop.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
      closeNav();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  var form = document.querySelector('.product-form');
  if (!form) return;

  var variants = (window.__productData && window.__productData.variants) || [];
  var variantInput = form.querySelector('.product-form__variant-id');
  var addBtn = form.querySelector('[name="add"]');

  /* Image gallery */
  document.querySelectorAll('.product-thumbnail').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('product-main-image');
      if (mainImg) {
        mainImg.src = this.dataset.src;
        mainImg.srcset = this.dataset.srcset || '';
        mainImg.alt = this.dataset.alt || '';
      }
      document.querySelectorAll('.product-thumbnail').forEach(function (t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* Quantity +/- */
  document.querySelectorAll('.quantity-selector').forEach(function (el) {
    var input = el.querySelector('.quantity-selector__input');
    el.querySelector('[aria-label="Decrease quantity"]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || 1) - 1);
    });
    el.querySelector('[aria-label="Increase quantity"]').addEventListener('click', function () {
      input.value = parseInt(input.value || 1) + 1;
    });
  });

  /* Variant selection */
  function getSelectedOptions() {
    var opts = [];
    form.querySelectorAll('.product-option').forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function updateVariant() {
    var opts = getSelectedOptions();
    var variant = findVariant(opts);
    if (!variant) return;

    variantInput.value = variant.id;

    /* Update button */
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? formatMoney(variant.price) + ' | ADD' : 'Sold Out';
    }

    /* Update URL */
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    /* Update main image if variant has one */
    if (variant.featured_image) {
      var mainImg = document.getElementById('product-main-image');
      if (mainImg) mainImg.src = variant.featured_image.src;
      document.querySelectorAll('.product-thumbnail').forEach(function (t) {
        t.classList.remove('is-active');
        if (t.dataset.src === variant.featured_image.src) t.classList.add('is-active');
      });
    }
  }

  function formatMoney(cents) {
    var fmt = window.__productData && window.__productData.moneyFormat;
    return window.Shopify && window.Shopify.formatMoney && fmt
      ? window.Shopify.formatMoney(cents, fmt)
      : '$' + (cents / 100).toFixed(2);
  }

  form.querySelectorAll('.product-option input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', updateVariant);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
